"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedYouTubePartialForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../../dsl/backoffice");
const version_abstract_form_1 = require("../version.abstract.form");
let EmbedYouTubePartialForm = class EmbedYouTubePartialForm extends version_abstract_form_1.EmbedVersionAbstractForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.regex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch?))\??v?=?([^#&?"]*).*/;
    }
    /**
     * Checks whether content contains related file
     */
    get hasImage() {
        return !!this._content.thumbnail && typeof this._content.thumbnail.value !== 'undefined';
    }
    get url() {
        if (!this._content || !this._content.videoId) {
            return '';
        }
        else {
            return `https://www.youtube.com/watch?v=${this._content.videoId}`;
        }
    }
    set url(url) {
        if (!url) {
            return;
        }
        const youtubeMatch = url.match(this.regex);
        if (youtubeMatch) {
            this.onVideoIdChange(youtubeMatch[7]);
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: '' }),
    __metadata("design:type", String)
], EmbedYouTubePartialForm.prototype, "imgTitle", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedYouTubePartialForm.prototype, "onAutoplayToggle", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedYouTubePartialForm.prototype, "onSelection", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedYouTubePartialForm.prototype, "onRemove", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedYouTubePartialForm.prototype, "onVideoIdChange", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], EmbedYouTubePartialForm.prototype, "thumbnail", void 0);
EmbedYouTubePartialForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedYouTubePartialForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixFile: backoffice_1.DashmixFile
        },
        template: `
      <div class="form-group">
        <div class="form-group">
          <label for="iframe">{{ $t('forms.embed.iframe.label.youtube') }}</label>
          <DashmixTextArea :model.sync="url" :placeholder="$t('forms.embed.iframe.placeholder.youtube')" name="iframe" />
          <small>{{$t('forms.embed.helpers')}}</small>
        </div>

        <label for="videoId" class="mt-3">{{ $t('forms.embed.videoId') }}</label>
        <DashmixInput :model="_content.videoId" name="videoId" disabled />

        <DashmixCheck class="mt-2" :model="_content.autoplay" @update:model="onAutoplayToggle" name="autoplay"
                      label="Auto-odtwarzanie po najechaniu" />

        <label for="description" class="mt-3">{{ $t('forms.embed.description') }}</label>
        <DashmixInput :model.sync="_content.description" name="description" />

      <div class="form-group">
            <p class="my-3"><b>{{ $t('forms.embed.thumbnail') }}</b></p>

            <DashmixButton v-if="!hasImage" variant="alt"
                           :icon="DashmixIconName.SearchSolid"
                           :label="$t('forms.shared.search')"
                           @click="onSelection" />

            <template v-if="hasImage">
              <template v-if="thumbnail">
                <div class="row">
                  <div class="col-3">
                    <figure class="figure-with-btn__image-container">
                      <DashmixButton class="figure-with-btn__delete-btn" variant="icon" theme="danger" :icon="DashmixIconName.TrashSolid" @click="onRemove" />
                      <DashmixFile class="figure-with-btn__image" :file="thumbnail" />
                      <figcaption>{{ imgTitle }}</figcaption>
                    </figure>
                  </div>
                </div>
              </template>

              <template v-else>
                <p class="my-3"><b>{{ $t('forms.image.not-found', { id: _content.thumbnail.value }) }}</b></p>
              </template>
            </template>
          </div>
      </div>
  `
    })
], EmbedYouTubePartialForm);
exports.EmbedYouTubePartialForm = EmbedYouTubePartialForm;
//# sourceMappingURL=EmbedYouTube.form.js.map